import React from 'react';

export const Photographer = React.lazy(() => import('./Photographer'));
